import React from "react";
import { Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import styled from "styled-components";
import { formatToDateOnly } from "lib-core";
import { useBlendedSnapshot } from "../../library/blendedSnapshot-hook";
import {
  Container,
  TitleBox,
  TextContainer,
  InnerContainer,
} from "./snapshotBoxes.styles";
import { BlendedSnapshotHistoryDialog } from "./BlendedSnapshotHistoryDialog";

const BlendedSnapshotContainer = styled(Container)`
  margin: 0 20px;
`;

const BSInnerContainer = styled(InnerContainer)`
  flex-direction: column;
`;

const GreyedTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.brandGray.dark};
`;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SnapshotProps {}

const BlendedSnapshotBox: (props: SnapshotProps) => JSX.Element | null = () => {
  const {
    isFetchingBlendedSnapshots,
    isAllowed,
    isErrorFetchingBlendedSnapshots,
    blendedSnapshots,
    usableSnapshots,
    latestUsableSnapshot,
    isLastSnapshotFailed,
    blendedSnapshotUpcoming,
    downloadBlendedSnapshotMetadata,
  } = useBlendedSnapshot();

  const versionString = (() => {
    if (isFetchingBlendedSnapshots) {
      return "Loading blended snapshot";
    }
    if (isErrorFetchingBlendedSnapshots) {
      return "There was an error loading blended snapshots";
    }
    if (usableSnapshots?.length === 0) {
      return "There are no Blended Snapshots for this protocol";
    }
    if (latestUsableSnapshot) {
      return `V${latestUsableSnapshot.version}.0 created on ${formatToDateOnly(
        latestUsableSnapshot.createdOn
      )}`;
    }
    return `No usable blended snapshots`;
  })();

  if (!isAllowed) {
    return null;
  }

  return (
    <>
      <BlendedSnapshotContainer>
        <TitleBox>
          <GreyedTypography variant="h4">
            Blended snapshot{" "}
            {isLastSnapshotFailed && (
              <WarningIcon
                color="error"
                style={{ verticalAlign: "middle", marginLeft: 15 }}
              />
            )}
          </GreyedTypography>
        </TitleBox>
        <BSInnerContainer>
          <TextContainer>
            <GreyedTypography variant="body1">{versionString}</GreyedTypography>
          </TextContainer>
          <BlendedSnapshotHistoryDialog
            blendedSnapshots={blendedSnapshots}
            latestUsableSnapshot={latestUsableSnapshot}
            blendedSnapshotUpcoming={blendedSnapshotUpcoming}
            downloadBlendedSnapshotMetadata={downloadBlendedSnapshotMetadata}
          />
        </BSInnerContainer>
      </BlendedSnapshotContainer>
    </>
  );
};

export default BlendedSnapshotBox;
